import { Button, IconButton, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useDialog } from "lib/@hooks/useDialog"
import { If, Else } from "lib/@components/switch"
import { LegislationLibraryChooseFolderDialog } from "./legislation-library-choose-folder-dialog"

const LABEL_SX = { color: "text.secondary", fontWeight: 600, letterSpacing: 0.5 }

export function LegislationLibraryDestinationField({ id }) {
    const [selected, setSelected] = useBoundValue("destinationParentId", "")
    const openChooseFolder = useDialog(<LegislationLibraryChooseFolderDialog id={id} />, {
        maxWidth: "sm",
        fullWidth: true,
    })

    const label = "Move to another folder"
    const buttonLabel = selected ? "Change" : "Choose Folder…"

    return (
        <Stack spacing={0.5} data-cy="legislation-destination-field">
            <Typography variant="overline" sx={LABEL_SX}>
                {label}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1}>
                <If value={!!selected}>
                    <Typography data-cy="legislation-destination-selected">{selected?.path}</Typography>
                    <IconButton
                        size="small"
                        onClick={handleClear}
                        aria-label="Clear destination folder"
                        data-cy="legislation-destination-clear"
                    >
                        <Iconify icon="mdi:close" width={18} height={18} />
                    </IconButton>
                    <Else>
                        <Typography color="text.secondary">Not selected</Typography>
                    </Else>
                </If>
                <Button size="small" onClick={handleChoose} data-cy="legislation-destination-choose">
                    {buttonLabel}
                </Button>
            </Stack>
        </Stack>
    )

    async function handleChoose() {
        const chosen = await openChooseFolder()
        if (chosen !== undefined) setSelected(chosen)
    }

    function handleClear() {
        setSelected("")
    }
}
